import axios from 'axios';
import config from "../../config";
const apiurl = config.ADMIN_BASE_URL;

export const fetchSortedPosts = async (searchFields, searchValues, page) => {
  const token = localStorage.getItem('cookies'); // Retrieve the token from localStorage
  try {
    const queryParams = searchFields
      .map((field) => `${field}=${encodeURIComponent(searchValues[field])}`)
      .join('&');

    const response = await axios.get(`${apiurl}/posts/sort?${queryParams}&page=${page}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching sorted posts:', error);
    throw error;
  }
};
